

import { instantiate } from './fish-trader-web-wasm-js.uninstantiated.mjs';


const exports = (await instantiate({

})).exports;

export const {
    main,
    memory,
    _initialize,
    startUnitTests
} = exports;

